module.exports = __webpack_public_path__ + "dotgreen1.png";